


















































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class CompaniesSwitcher extends Vue {
  @Provide("$_") $_: any;

  @Prop() private currentId!: string;

  private currentCompany = { id: null };

  @Watch("currentId")
  updateCurrentCompany() {
    const companies = this.$store.getters.companies;

    let currentCompany;
    if (companies.length === 1) {
      currentCompany = companies[0];
    } else {
      currentCompany = this.$_.find(companies, (o) =>
        this.currentId ? o.id == this.currentId : o.isDefault
      );
    }
    this.currentCompany = currentCompany;
    this.$store.commit("recordCurrentCompany", this.currentCompany.id);
  }

  openChooser() {
    (this.$refs["company-chooser"] as any).showModal();
  }
  closeChooser() {
    (this.$refs["company-chooser"] as any).close();
  }

  chooseCompany(id) {
    this.closeChooser();

    this.$emit("company-switched", { companyId: id });
  }

  mounted() {
    this.updateCurrentCompany();
  }
}
